import { createAsyncAction } from "utils/actionCreators";

export const types = {
  PROCESSAR: "@@carga-processos/PROCESSAR",
};

export const actions = {
  processar: createAsyncAction(types.PROCESSAR),
};
